<air-section [loading]="loading">
    <div class="cosmos-section__title mb-1">{{ title }}</div>
    <ng-content></ng-content>
</air-section>